import React from "react";
import {trans, widget} from "../../../modulesCompiler";
import artikli from "../../../../assets/images/6500-artikala.png";
import deliveryTruck from "../../../../assets/images/delivery-truck.png";
import helping from "../../../../assets/images/helping.png";
import rating from "../../../../assets/images/rating.png";

function About() {


    return (
        <div className="container">
            {widget("public.Breadcrumbs", {links: [{trans: trans("Politika privatnosti")}]})}

            <div className="bg-white rounded-3 p-4 mb-6">
                <h2 className="text-uppercase fw-bold text-secondary mb-4 text-center">Politika privatnosti</h2>

                <h4 className="fw-bold mt-4">Uvod</h4>
                <p>
                    Molimo Vas da pažljivo pročitate ovu Politiku privatnosti kako biste razumeli način na koji
                    prikupljamo, koristimo i obrađujemo Vaše lične podatke. Detaljno ćemo objasniti načine na koje
                    štitimo Vašu privatnost, kako možete da proverite i pristupite Vašim podacima u bilo kom trenutku,
                    da zahtevate njihovu ispravku i brisanje, i kako se vrši nadzor nad strogom primenom ove politike.
                </p>
                <p>
                    Ova Politika privatnosti odnosi se na sajt kompanije <strong>Barok Dizajn DOO</strong> (<a
                    href="https://www.barok032.rs" target="_blank">www.barok032.rs</a>) koji uređuje Barok Dizajn DOO.
                    (u nastavku Barok)
                </p>

                <h4 className="fw-bold mt-4">Saglasnost</h4>
                <p>
                    Korišćenjem www.barok032.rs, dajete saglasnost na uslove ove Politike privatnosti. Barok zadržava
                    pravo da povremeno izmeni uslove iz ove Politike privatnosti.
                </p>

                <h4 className="fw-bold mt-4">Kategorije podataka o ličnosti i svrhe obrade</h4>
                <p>
                    Vrsta i količina podataka koje primamo i čuvamo zavisi od načina na koji koristite sajt Baroka.
                    Možete da pristupite većini stranica na sajtu Baroka bez otkrivanja Vašeg identiteta ili bilo kog
                    podatka o ličnosti. Naši mrežni serveri prikupljaju anonimne logove tokom korisničke posete
                    Barokovog sajta kako bi nas snabdeli korisnim informacijama za njeno unapređenje, kao i prilikom
                    slanja upita na stranici sa formularom koji korisnik sajta popunjava, po želji. Za više informacija,
                    molimo Vas da pogledate Izjavu o korišćenju kolačića koja se nalazi niže.
                </p>
                <p>
                    Možemo da koristimo vaše lične podatke u promotivne svrhe, pre svega kako bismo vam predstavili i
                    pokazali reklamne i promotivne materijale kompanije Barok. Tražićemo od vas dozvolu za prosleđivanje
                    reklamnog materijala ili informacija o proizvodima pre samog slanja reklamnog i promotivnog
                    materijala. U svakom trenutku možete podneti prigovor na način na koji se vaši lični podaci obrađuju
                    u svrhe direktnog oglašavanja. Ovakav Vaš zahtev treba biti potpisan i datiran, sa jasnom naznakom
                    obradi kojih Vaših ličnih podataka prigovarate i iz kojih razloga. Vaš prigovor možete slati na
                    način naveden u Odeljku 7 (Kontaktirajte nas) ispod.
                </p>
                <p>
                    Vaši lični podaci će se čuvati u tajnosti. Koristiće se samo u svrhe za koje su preuzeti, ili
                    ukoliko je potrebno radi našeg usaglašavanja sa zakonskim obavezama.
                </p>

                <h4 className="fw-bold mt-4">Metapodaci</h4>
                <p>
                    Naš vebsajt možete koristiti sa ili bez davanja bilo kakvih ličnih podataka, u zavisnosti od potrebe
                    konkretne situacije. U slučaju da ne ostavljate podatke o ličnosti, Barok može prikupljati samo
                    sledeće metapodatke na osnovu Vašeg korišćenja istih:
                </p>
                <p>
                    Stranicu sa koje ste došli do našeg vebsajta, datum i vreme pristupa, količinu prenetih podataka,
                    status prenosa, tip web-pretraživača, IP adresu, operativni sistem i interfejs, jezik i verziju
                    softvera pretraživača.
                </p>

                <h4 className="fw-bold mt-4">Prijava za posao</h4>
                <p>
                    Ukoliko se prijavite za posao u Baroku prikupićemo Vaše podatke radi obrade i procesuiranja Vaše
                    prijave i procene Vaše prikladnosti za tu ulogu. Podaci i CV-jevi kandidata prikupljeni ovim putem
                    koristiće se isključivo u svrhu selekcije biografija u skladu sa otvorenim pozicijama, stupanja u
                    kontakt sa aplikantima povodom razgovora za posao ili potencijalnog zaposlenja u kompaniji Barok, sa
                    čime su aplikanti saglasni i upoznati.
                </p>
                <p>
                    Naša internet stranica sadrži vezu ka drugim internet stranicama koje nisu pokrivene ovim
                    Obaveštenjem o privatnosti i kolačićima. Ako pristupate drugim internet stranicama korišćenjem
                    obezbeđenih veza, operateri tih internet stranica će moći da prikupljaju informacije od Vas koje će
                    oni koristiti u skladu sa svojim politikama o privatnosti, a koje se mogu razlikovati od naše. Barok
                    ne snosi odgovornost za podatke koje prikupljaju druge internet stranice.
                </p>

                <h4 className="fw-bold mt-4">Pravni osnov za obradu</h4>
                <ul>
                    <li>Dali ste pristanak na obradu Vaših podataka u jednu ili više konkretnih svrha;</li>
                    <li>Obrada je potrebna za realizaciju ugovora u kojem ste jedna od strana ili radi preduzimanja
                        koraka, na Vaš zahtev, a pre zaključivanja ugovora;
                    </li>
                    <li>Obrada je potrebna radi usaglašavanja sa zakonskim obavezama kojima podležemo;</li>
                    <li>Obrada je potrebna za izvršenje zadataka koji se vrše u javnom interesu ili u okviru sprovođenja
                        zvaničnih ovlašćenja koja su nam zakonom dodeljena;
                    </li>
                    <li>Obrada je potrebna radi legitimnih interesa koje nastojimo da zaštitimo mi ili treća strana,
                        osim kad nad takvim interesima pretežu Vaši interesi ili fundamentalna prava i slobode koja
                        zahtevaju zaštitu podataka o ličnosti, naročito ako ste dete, odnosno maloletna osoba;
                    </li>
                </ul>
                <p>
                    Vaše lične podatke dostavljate na dobrovoljnoj osnovi, sem ukoliko obaveza prikupljanja nije
                    predviđena kao naša zakonska obaveza. Nedostavljanje podataka o ličnosti može dovesti do nepovoljnih
                    aspekata za Vas kao korisnika, npr. nećete moći da primate određene servise, pogodnosti i usluge.
                    Međutim, osim ukoliko se ne navodi drugačije, ne-pružanje Vaših podataka o ličnosti ne povlači sa
                    sobom druge pravne posledice po Vas.
                </p>

                <h4 className="fw-bold mt-4">Koja prava imate i kako možete da ih iskoristite?</h4>
                <p>
                    Ako ste dali pristanak na određeno prikupljanje, obradu i korišćenje Vaših podataka o ličnosti,
                    možete opozvati saglasnost u bilo kom trenutku, sa dejstvom za ubuduće.
                </p>
                <p>
                    Prema merodavnim propisima o zaštiti podataka, imate pravo (i) da tražite pristup i uvid u Vaše
                    podatke o ličnosti, (ii) da tražite ispravku ili dopunu Vaših podataka o ličnosti, (iii) da tražite
                    brisanje Vaših podataka o ličnosti, (iv) da tražite ograničavanje obrade Vaših podataka o ličnosti,
                    (v) da tražite prenosivost podataka, (vi) da prigovorite obradi Vaših podataka o ličnosti.
                </p>
                <p>
                    Kako biste iskoristili svoja prava ili podneli prigovor na način na koji se vaši lični podaci
                    obrađuju, kontaktirajte nas na način naveden u Odeljku 7 (Kontaktirajte nas) ispod. Vaš zahtev u
                    vezi sa korišćenjem prava u vezi sa Vašim ličnim podacima pošaljite sa jasnom naznakom: kojim Vašim
                    podacima o ličnosti želite da izvršite pristup i uvid, koje Vaše lične podatke želite da dopunite,
                    ispravite ili izbrišete, odnosno obradi kojih Vaših ličnih podataka se prigovarate i iz kojih
                    razloga. Ovakav Vaš zahtev treba biti potpisan i datiran. Barok će izaći u susret Vašem zahtevu što
                    je pre moguće i poslati Vam odgovarajuće obaveštenje.
                </p>

                <h4 className="fw-bold mt-4">Kolačići i druge tehnologije praćenja – Izjava o korišćenju kolačića</h4>
                <p>
                    Ovaj vebsajt i kao i većina sajtova, koristi male tekstualne datoteke koje se zovu kolačići. Ova
                    sekcija pruža informacije o tome šta su kolačići, koje kolačiće Barok koristi i kako se mogu
                    kontrolisati.
                </p>
                <p>
                    Ako su postavke na softveru koji koristite za pregled ove stranice (Vašem pretraživaču) prilagođene
                    da prihvate kolačiće koje koristimo, i nastavite da koristite naš sajt, podrazumevaćemo Vaš
                    pristanak. Ako ne želite da primate kolačiće, možete postaviti svoj pretraživač tako da ih ograniči
                    ili blokira. Svi savremeni pretraživači omogućavaju da promenite podešavanja kolačića i obično se
                    nalaze u meniju 'opcije'. Međutim, onemogućavanje kolačića će verovatno značiti da sajt Barok
                    neće raditi kao što je očekivano.
                </p>

                <h5 className="fw-semibold">4.1. Šta su kolačići?</h5>
                <p>
                    Kolačići su tekstualne datoteke sa malim količinama informacija koje Vaš uređaj preuzme kada
                    posetite sajt. Kolačići se zatim vraćaju na prvobitnu stranicu pri svakoj narednoj poseti ili na
                    drugu stranicu koja prepoznaje taj kolačić. Kolačići se često koriste jer omogućavaju sajtu da
                    prepozna korisnički uređaj I time poboljša funkcionalnost.
                </p>

                <h5 className="fw-semibold">4.2. Kako Barok koristi kolačiće?</h5>
                <p><strong>Naši kolačići</strong></p>
                <p>
                    Kako bi naš sajt radio što bolje, koristimo kolačiće koji uključuju:
                </p>
                <ul>
                    <li>Pamćenje parametara Vaših pretraga</li>
                    <li>Omogućavanje dodavanja komentara na našem sajtu</li>
                </ul>
                <p>
                    Ne postoji način da se ovi kolačići spreče, osim da ne koristite sajt.
                </p>

                <p><strong>Kolačići društvenih mreža</strong></p>
                <p>
                    Da biste jednostavno delili naš sadržaj na društvenim mrežama naš sajt ima dugmad za deljenje.
                    Stepen zaštite privatnosti podataka će se razlikovati od društvene mreže do društvene mreže, i
                    zavisiti od podešavanja privatnosti koju ste izabrali na ovim mrežama.
                </p>

                <p><strong>Kolačići za anonimno prikupljanje statistike o posetiocima</strong></p>
                <p>
                    Koristimo kolačiće za sakupljanje statističkih podataka o posetiocima, kao što su: koliko ljudi
                    posećuje naš sajt i koju vrstu tehnologije koriste (npr. operativni sistem, što pomaže da
                    identifikujemo probleme na određenim platformama), koliko dugo koriste sajt, na kojim stranicama
                    sajta se zadržavaju itd. Ovo nam pomaže da stalno poboljšavamo sajt. Ti programi takođe nam anonimno
                    govore kako su ljudi došli do našeg sajta (preko Gugla, društvenih mreža, direktno, itd) i da li su
                    ranije bili ovde.
                </p>

                <h5 className="fw-semibold">4.3. Definicije</h5>
                <p><strong>Kolačići prve strane i kolačići treće strane</strong></p>
                <p>
                    Kolačići prve strane su oni koje postavlja sajt koji u tom trenutku korisnik posećuje – sajt koji je
                    prikazan u polju za URL. Kolačiće treće strane postavlja domen koji ne pripada sajtu koji korisnik u
                    tom trenutku posećuje. Ako korisnik poseti sajt i drugi entitet postavi kolačić kroz taj sajt, to je
                    kolačić treće strane.
                </p>

                <p><strong>Trajni kolačići</strong></p>
                <p>
                    Ovi kolačići ostaju na korisničkom uređaju u vremenskom periodu navedenom u kolačiću. Oni se
                    aktiviraju svaki put kada korisnik poseti stranicu koja je kreirala taj određeni kolačić́.
                </p>

                <p><strong>Kolačići sesije</strong></p>
                <p>
                    Ovi kolačići omogućavaju povezivanje akcija korisnika tokom sesije pretraživača. Sesija pretraživača
                    počinje kada korisnik otvori prozor pretraživača i završava kada zatvori prozor pretraživača.
                    Kolačići sesije se kreiraju privremeno. Kada zatvorite pretraživač, svi kolačići sesije se brišu.
                </p>

                <h5 className="fw-semibold">4.4. Isključivanje kolačića</h5>
                <p>
                    Obično možete isključiti kolačiće prilagođavanjem podešavanja pretraživača da biste sprečili
                    prihvatanje kolačića. Međutim, verovatno ćete ograničiti funkcionalnost naših i velikog broja drugih
                    sajtova, jer su kolačići standardni deo većine savremenih sajtova.
                </p>

                <h4 className="fw-bold mt-4">Koliko čuvamo Vaše podatke o ličnosti?</h4>
                <p>
                    Vaši podaci o ličnosti zadržavaju se sve dok je to potrebno kako bismo Vam mogli dostaviti tražene
                    servise, pogodnosti i usluge. Kad se naš odnos završi, ili ćemo obrisati Vaše podatke o ličnosti ili
                    pak anonimizirati Vaše podatke o ličnosti, osim u slučaju da postoje zakonski zahtevi za zadržavanje
                    istih (na primer, za potrebe oporezivanja). Takođe, važeći zakonski propisi mogu zahtevati od nas da
                    zadržimo određene Vaše podatke o ličnosti tokom perioda od 10 godina nakon isteka relevantne poreske
                    godine. Možemo zadržati i Vaše podatke o ličnosti nakon raskida ugovornog odnosa ako su Vaši podaci
                    o ličnosti potrebni radi usaglašavanja sa drugim merodavnim zakonima ili ako su nam Vaši podaci o
                    ličnosti potrebni za utvrđivanje, ostvarivanje ili odbranu pravnih zahteva, samo kada je to
                    neophodno. U meri u kojoj je to moguće, ograničićemo obradu Vaših podataka o ličnosti u te
                    ograničene svrhe nakon završetka ugovornog odnosa.
                </p>

                <h4 className="fw-bold mt-4">Koliko su bezbedni vaši podaci?</h4>
                <p>
                    Vaše lične podatke Barok čuva u bezbednom okruženju. Preduzimamo odgovarajuće mere bezbednosti kako
                    bismo zaštitili Vaše lične podatke i informacije od neovlašćenog pristupa, korišćenja, gubitka ili
                    objavljivanja. Ovi sistemi i mere se redovno ažuriraju ukoliko je potrebno.
                </p>
                <p>
                    Uzimajući u obzir nivo tehnoloških dostignuća i troškove njihove primene, prirodu, obim, okolnosti i
                    svrhu obrade, prilikom obrade Vaših podataka:
                </p>
                <ul>
                    <li>primenjujemo odgovarajuće tehničke, organizacione i kadrovske mere, kao što je pseudonimizacija,
                        kako bi obezbedili obezbeđivanje delotvorne zaštite Vaših podataka o ličnosti,
                    </li>
                    <li>primenjujemo neophodne mehanizme zaštite u toku obrade, kako bi se ispunili uslovi za obradu
                        Vaših podataka i zaštitili Vaša prava.
                    </li>
                </ul>
                <p>
                    Ovim putem Vas obaveštavamo da stalnom primenom odgovarajućih tehničkih, organizacionih i kadrovskih
                    mera obezbeđujemo da se uvek obrađuju samo oni Vaši podaci o ličnosti koji su neophodni za
                    ostvarivanje svake pojedinačne svrhe obrade. Ta se obaveza primenjuje u odnosu na broj prikupljenih
                    podataka, obim njihove obrade, rok njihovog pohranjivanja i njihovu dostupnost.
                </p>
                <p>
                    Ipak, prenos informacija putem Interneta nikada nije u potpunosti bezbedan, pa iako se trudimo da
                    zaštitimo lične podatke, ne možemo garantovati sigurnost informacija prenetih putem sajta i Baroka.
                </p>

                <h4 className="fw-bold mt-4">Kontaktirajte nas</h4>
                <p>
                    Barok posvećeno štiti privatnost svih korisnika svog vebsajta. Ukoliko imate bilo kakvo pitanje u
                    vezi sa ovom Politikom privatnosti, molimo Vas da nam se obratite koristeći kontakt podatke navedene
                    ispod. Ova Politika privatnosti važi za sve stranice na sajtu Baroka. Ne primenjuje se na Internet
                    stranice drugih organizacija, uključujući i Internet stranice bliskih organizacija i stranice trećih
                    strana. Internet prezentacija Baroka može da sadrži linkove prema Internet stranama takvih
                    organizacija, koje imaju sopstvenu politiku privatnosti koja se na njih primenjuje.
                </p>
                <p>
                    Ako imate bilo kakvih pitanja u vezi s ovom Politikom privatnosti, kontaktirajte nas:
                </p>
                <p>
                    Barok Dizajn DOO, Put za Šebeke 10, Konjevići, 32000 Čačak<br/>
                    Phone: 032/382-077<br/>
                    E-mail: barokdizajn@gmail,com
                </p>
            </div>

        </div>
    )
}

export default About;